export class MailPublipostageParams {
  contactIds?: number[];
  contactiAdminIds?: number[];
  contactsLibres?: {
    titre?: string;
    nom?: string;
    prenom?: string;
    adresse?: string;
    cp?: string;
    loc?: string;
    mail?: string;
    societe?: string;
    tel?: string;
    fax?: string;
  }[];
  pdf?: boolean;
  fusion?: boolean;
}
